export class HotspotButton extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.initialise()
  }

  initialise () {
    this.isInViewport()
  }

  isInViewport () {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    }
    const callback = (entries, observer) => {
      entries.forEach(entry => {
        this.classList.toggle(
          'sec-Hotspots_Hotspot-animate',
          entry.isIntersecting,
        )
      })
    }

    const observer = new IntersectionObserver(callback, options)
    observer.observe(this)
  }
}

if (!customElements.get('hotspot-button')) {
  customElements.define('hotspot-button', HotspotButton)
}
